<template>
    <div class="comp-list-view lecto-favorite" v-loading="loading == -1">
      <div class="comp-list-con-div">
        <div class="comp-list-con">
          <el-table
            :data="dataList"
            size="mini"
            empty-text="暂无数据"
            style="width: 100%">
            <el-table-column
              label="序号"
              align="center"
              width="50px"
              type="index">
            </el-table-column>
            <el-table-column label="产品图" width="80" align="center">
              <template slot-scope="scope">
                <prod-icon :src="scope.row.ProdLogo" :width="40" :height="40"></prod-icon>
              </template>
            </el-table-column>
            <el-table-column label="产品名称">
              <template slot-scope="scope">
                <span>{{scope.row.ProdName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="下载" align="center" width="200">
              <template slot-scope="scope">
                <span>{{scope.row.DownNums}}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="80">
                <template slot-scope="{ row }">
                    <span :class="getProdState(row).class">{{ getProdState(row).text }}</span>
                </template>
            </el-table-column>
            <el-table-column
              label="查看"
              width="150"
              align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="_skuDetail(scope.row)" v-if="scope.row.State === 6">查看</el-button>
                <el-button type="text" size="small" :disabled="true" title="产品未上架" v-else>产品未上架</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
  
      <div class="pagination">
        <md-page :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
      </div>
    </div>
  </template>
  
  <script>
  //引入服务
  import {OpenService,ProductService} from "@/service";
  
  import ProdIcon from "/@/components/icon/prod-icon.vue";
  import SvgDrag from '@/components/svg/drag.vue';
  import MdPage from '@/components/md-page.vue';
  
  export default{
    components: { SvgDrag, MdPage, ProdIcon },
    props: {
      dirId: { default: 0 },
      listType: { default: '' },
      cateParents: { default: [] },
    },
    watch: {
      dirId (value) {
        this.lectoDirId = value;
        this.listType.includes('ProdDir') && (this.loadList(true));
      }
    },
    data() {
      return {
        lectoDirId: 0,
        dataList: [],
        loading: 0, //状态  -1加载中 0 未加载  1 加载完成
        page: 1,
        pageSize: 20,
        total: 0,
      }
    },
    methods: {
  
      async loadList(isFirst = false) {
        //加载产品列表
        this.loading = -1;
        isFirst && (this.page = 1)
        
        const res = await ProductService.getList(
            this.page,
            '',
            this.lectoDirId,
            0,
            this.pageSize,
        );
        this.loading = 1;
        if (res) {
          this.dataList = res.List || [];
          this.total = res.TotalCount;
        }
      },
  
      pageChanged(param) {
        this.page = param.page;
        this.loadList();
      },

        getProdState(row) {
            switch (row.State) {
                case 0:
                    return { class: "", text: "新建" };
                    break;
                case 1:
                    return { class: "color-red", text: "已下架" };
                    break;
                case 2:
                    return { class: "color-red", text: "迈迪下架" };
                    break;
                case 6:
                    return { class: "color-blue", text: "已上架" };
                    break;
                default:
                    return "";
                    break;
            }
        },
  
      _skuDetail(value) {
        OpenService.openProdDetails(value.ID);
      },
    },
  }
  </script>
  
  <style lang="less" scope>
  .table-name{
    margin: 0;
    font-size: 14px;
    &.remark{
      font-size: 14px;
      font-weight: bold;
    }
  }
  .comp-list-view{
    display: flex;
    /deep/ .el-empty{
      flex: 1;
    }
    /deep/ th{
      padding: 2px 0;
      color: #409EFF;
    }
  }
  .comp-list-con-div{
    flex: 1;
    height: calc(100vh - 20px - 43px);
    overflow-y: auto;
    padding-bottom: 40px;
  }
  .comp-list-con{
    display: flex;
    flex-wrap: wrap;
    padding: 0 5px 10px 5px;
    flex: 1;
  }
  .edit-view{
    position: absolute;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    opacity: 0;
    transform: translateY(26px);
    transition: all 0.4s;
    i{
      width: 26px;
      height: 26px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .exist-span{
      width: 120px;
      height: 26px;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .drag-edit{
      cursor: move;
    }
  }
  .comp-list-con{
    /deep/ .list-card:hover .edit-view{
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .pagination{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
  }
  </style>
  